module.exports = __webpack_public_path__ + "img/laft_bg.702f8cf7.png";